import React from "react"
import styles from "./styles.scss"
import YAxisTick from "./YAxisTick"

class YAxis extends React.PureComponent {
  render() {
    const { steps, iconWidth } = this.props

    return (
      <div className={styles.yAxis}>
        <span />
        {steps.map(step => (
          <YAxisTick key={step.icon} iconWidth={iconWidth} />
        ))}
        <span />
      </div>
    )
  }
}

export default YAxis



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Chart/YAxis/index.jsx